import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";

import TopBar from "./components/hts/TopBar";
import QualifyBar from "./components/hts/QualifyBar";
import Hero from "./components/hts/Hero";
import Recognition from "./components/hts/Recognition";
import SkillLadder from "./components/hts/SkillLadder";
import LessonPoints from "./components/hts/LessonPoints";
import Phases from "./components/hts/Phases";
import Mentor from "./components/hts/Mentor";
import Testimonials from "./components/hts/Testimonials";
import ForWhom from "./components/hts/ForWhom";
import LiveSession from "./components/hts/LiveSession";
import Application from "./components/hts/Application";
import Faq from "./components/hts/Faq";
import Footer from "./components/hts/Footer";
import StickyCTA from "./components/hts/StickyCTA";
import VslPage from "./components/hts/vsl/VslPage";
import OfferPage from "./components/hts/offer/OfferPage";
import CookieConsent from "./components/CookieConsent";

export const goTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

function MainLanding() {
  return (
    <>
      <QualifyBar />
      <TopBar />
      <main>
        <Hero />
        <Recognition />
        <SkillLadder />
        <LessonPoints />
        <Phases />
        <Mentor />
        <Testimonials />
        <ForWhom />
        <LiveSession />
        <Application />
        <Faq />
      </main>
      <Footer />
      <StickyCTA />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<VslPage />} />
          <Route path="/vsl" element={<VslPage />} />
          <Route path="/mentorship" element={<MainLanding />} />
          <Route path="/offer" element={<OfferPage />} />
        </Routes>
        <Toaster position="top-center" theme="dark" />
        <CookieConsent />
      </BrowserRouter>
    </div>
  );
}

export default App;
